document.querySelectorAll(".toggle-popup").forEach(function(obj) {
  obj.addEventListener("click", function(e) {
    var target = obj.getAttribute("data-target");
    var target_popup = document.getElementById(target);
    target_popup.classList.add("opened");
    if(target_popup.querySelector(".content-slider") && !target_popup.querySelector(".content-slider").classList.contains("flickity-enabled")) {
      var flkty = new window.ThemeFlickity( target_popup.querySelector(".content-slider"), {
        "pageDots": false
      });
    }
  });
});

document.querySelectorAll(".popup .btn-close").forEach(function(obj) {
  obj.addEventListener("click", function(e) {
    var popup = obj.closest(".popup");
    popup.classList.remove("opened");
  });
});

document.querySelectorAll(".popup").forEach(function(obj) {
  obj.addEventListener("click", function(e) {
    if(e.target.closest(".popup-inner") == null) {
      obj.classList.remove("opened");
    }
  });
});

function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

// function updatePrice() {
//   var tot_price = parseInt(document.querySelector(".product-form__variants .block-swatch__radio:checked+.block-swatch__item .sale_price").getAttribute("data-price"));
//   var tot_regprice = parseInt(document.querySelector(".product-form__variants .block-swatch__radio:checked+.block-swatch__item .reg_price").getAttribute("data-price"));

//   document.querySelectorAll(".addon-btn.added").forEach(function(obj1) {
//     tot_price += parseInt(obj1.getAttribute("data-price"));
//     tot_regprice += parseInt(obj1.getAttribute("data-regprice"));
//   });

//   const comparePrice = document.querySelector(".price-list .price--compare .money");
//   const highlightPrice = document.querySelector(".price-list .price--highlight .money");
//   const stickyPrice = document.querySelector(".product-sticky-form__price");
//   const stickyComparePrice = document.querySelector(".product-sticky-form .price--compare .money");
//   if (comparePrice) comparePrice.textContent = formatMoney(tot_regprice);
//   if (highlightPrice) highlightPrice.textContent = formatMoney(tot_price);  
//   if (stickyPrice) stickyPrice.textContent = formatMoney(tot_price);
//   if (stickyComparePrice) stickyComparePrice.textContent = formatMoney(tot_regprice);
// }





// Strictly-scoped updatePrice: will NOT modify global price lists (cart drawer, mini-cart, etc.)
function updatePrice(productContainer) {
  if (!productContainer) return;
  var checkedRadio = productContainer.querySelector('.block-swatch__radio:checked');
  if (!checkedRadio) return;
  var selectedLabel = checkedRadio.nextElementSibling || checkedRadio.closest('.block-swatch__item') || null;

  function toCents(val) {
    var n = parseInt(val, 10);
    return isNaN(n) ? 0 : n;
  }

  var saleEl = selectedLabel ? selectedLabel.querySelector('.sale_price') : null;
  var regEl = selectedLabel ? selectedLabel.querySelector('.reg_price') : null;

  var saleData = saleEl ? saleEl.getAttribute('data-price') : null;
  var regData = regEl ? regEl.getAttribute('data-price') : null;

  var tot_price = toCents(saleData !== null ? saleData : (saleEl && saleEl.textContent ? saleEl.textContent.replace(/[^0-9.-]+/g, "") : 0));
  var tot_regprice = toCents(regData !== null ? regData : (regEl && regEl.textContent ? regEl.textContent.replace(/[^0-9.-]+/g, "") : 0));
  console.log("tot_price: ", tot_price);
  console.log("tot_regprice: ", tot_regprice);

  var addons = productContainer.querySelectorAll ? productContainer.querySelectorAll('.addon-btn.added') : [];
  addons.forEach(function (a) {
    tot_price += toCents(a.getAttribute('data-price'));
    tot_regprice += toCents(a.getAttribute('data-regprice'));
  });


  var priceList = productContainer.querySelector('[data-product-price-list]');
  console.log("priceList: ", priceList);
  if (!priceList) {
    console.log("if");
  } else {
    console.log("else");

    var ifInCart = priceList.closest('.drawer__content, .mini-cart, .mini-cart-drawer, #CartDrawer, .cart-drawer, .ajax-cart, .cart-popup');
    if (!ifInCart) {

    console.log("!ifInCart");
      var compareEl = priceList.querySelector('.price--compare');
      var highlightEl = priceList.querySelector('.price--highlight') || priceList.querySelector('.price--large');

      function setMoney(targetEl, cents) {
        if (!targetEl) return;
        console.log("!targetEl: ", targetEl);
        var money = targetEl.querySelector('.money');
        var text = (typeof formatMoney === 'function') ? formatMoney(cents) : ((cents / 100).toFixed(2));
        if (money) money.textContent = text;
        else targetEl.innerHTML = '<span class="visually-hidden">Price</span><span class="money">' + text + '</span>';
      }

      if (tot_regprice > 0 && tot_regprice > tot_price) {
        console.log("!tot_regprice");
        if (!compareEl) {
          console.log("!compareEl");
          priceList.insertAdjacentHTML('afterbegin', '<span class="price price--compare"><span class="visually-hidden">{{ "product.general.regular_price" | t }}</span><span class="money"></span></span>');
          compareEl = priceList.querySelector('.price--compare');
        }
        if (!highlightEl || !highlightEl.classList.contains('price--highlight')) {
          if (highlightEl && highlightEl.classList.contains('price--large')) {
            highlightEl.classList.remove('price--large');
            highlightEl.classList.add('price--highlight', 'price--large');
          } 
          else if (!highlightEl) {
            priceList.insertAdjacentHTML('beforeend', '<span class="price price--highlight price--large"><span class="visually-hidden">{{ "product.general.sale_price" | t }}</span><span class="money"></span></span>');
          }
          highlightEl = priceList.querySelector('.price--highlight');
        }
        setMoney(compareEl, tot_regprice);
        setMoney(highlightEl, tot_price);
      } 
      else {
        console.log("!elseee");
        if (compareEl) compareEl.parentNode.removeChild(compareEl);
        if (highlightEl && highlightEl.classList.contains('price--highlight')) {
          highlightEl.classList.remove('price--highlight');
          highlightEl.classList.add('price--large');
          setMoney(highlightEl, tot_price);
        } else if (highlightEl) {
          setMoney(highlightEl, tot_price);
        } else {
          priceList.insertAdjacentHTML('beforeend', '<span class="price price--large"><span class="visually-hidden">{{ "product.general.sale_price" | t }}</span><span class="money">' + ((typeof formatMoney === 'function') ? formatMoney(tot_price) : (tot_price / 100).toFixed(2)) + '</span></span>');
        }
      }
    }
  }


  var stickyForm = document.querySelector('.product-sticky-form');
  if (stickyForm) {
    var priceText = (typeof formatMoney === 'function') ? formatMoney(tot_price) : (tot_price / 100).toFixed(2);


    var stickyPriceEl = stickyForm.querySelector('.product-sticky-form__price');
    if (stickyPriceEl) {
      var spMoney = stickyPriceEl.querySelector('.money');
      if (spMoney) {
        spMoney.textContent = priceText;
      } else {
        stickyPriceEl.innerHTML = '<span class="money">' + priceText + '</span>';
      }
    }

    // Update or create/remove the sticky compare price (only inside stickyForm)
    var stickyCompareEl = stickyForm.querySelector('.price--compare');
    if (tot_regprice > 0 && tot_regprice > tot_price) {
      var compareText = (typeof formatMoney === 'function') ? formatMoney(tot_regprice) : (tot_regprice / 100).toFixed(2);
      if (stickyCompareEl) {
        var scMoney = stickyCompareEl.querySelector('.money');
        if (scMoney) scMoney.textContent = compareText;
        else stickyCompareEl.innerHTML = '<span class="visually-hidden">{{ "product.general.regular_price" | t }}</span><span class="money">' + compareText + '</span>';
      } else {
        stickyForm.insertAdjacentHTML('afterbegin', '<span class="price price--compare"><span class="visually-hidden">{{ "product.general.regular_price" | t }}</span><span class="money">' + compareText + '</span></span>');
      }
    } else {
      if (stickyCompareEl) stickyCompareEl.parentNode.removeChild(stickyCompareEl);
    }
  }
}

// DOMContentLoaded initializer: find product containers and run updatePrice for each
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-product-price-list]').forEach(function (priceListEl) {
    var ancestor = priceListEl;
    while (ancestor && ancestor !== document.documentElement) {
      if (ancestor.querySelector && ancestor.querySelector('.block-swatch__radio')) break;
      ancestor = ancestor.parentElement;
    }
    if (!ancestor || ancestor === document.documentElement) {
      return;
    }
    updatePrice(ancestor);
  });
});


// call updatePrice on initial page load for each price-list found
document.addEventListener('DOMContentLoaded', function () {
  console.log("code ran");
  document.querySelectorAll('[data-product-price-list]').forEach(function (priceListEl) {
    // find the nearest ancestor container that contains the variant radios
    var ancestor = priceListEl;
    while (ancestor && ancestor !== document) {
      if (ancestor.querySelector && ancestor.querySelector('.block-swatch__radio')) break;
      ancestor = ancestor.parentElement;
    }
    // fallback to priceListEl.parentElement if nothing found
    var productContainer = ancestor && ancestor !== document ? ancestor : priceListEl.parentElement;
    try {
      updatePrice(productContainer);
    } catch (e) {
      // harmless if updatePrice can't run for some reason
      console.warn('updatePrice init error', e);
    }
  });
});

















document.querySelectorAll(".addon-btn").forEach(function(obj) {
  obj.addEventListener("click", async function(e) {
    var addOnVariantId = this.getAttribute("data-id");

    if (this.classList.contains("added")) {
      console.log("doing nothing on add button click");
      return;
    } 

    this.classList.toggle("added")
    console.log("skipping old 'bundle' logic to add product to list")

    let payload = {
      "items": [
        {
          "quantity": 1,
          "id": addOnVariantId
        }
      ]
    }

    const addToCartResponse = await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
      body: JSON.stringify(payload),
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With':'xmlhttprequest'
      }
    });

    if (!addToCartResponse.ok) {
      console.error("failed to add add on product to cart");
      this.classList.toggle("added");
      return;
    }
    let addToCartResponseJson = await addToCartResponse.json();

    fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (cartResponse) => {
      const cartContent = await cartResponse.json();
      console.log(cartContent);
      document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
        bubbles: true,
        detail: {
          cart: cartContent
        }
      }));
      cartContent["sections"] = addToCartResponseJson["sections"];
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: {
          cart: cartContent,
          openMiniCart: window.themeVariables.settings.cartType === "drawer" && this.closest(".drawer") === null
        }
      }));
    });

  });
});

document.addEventListener("variantChanged", function(e) {
  var variant_id = e.detail.id;
  var targetElement = e.target;
  if (!targetElement || !(targetElement instanceof Element)) {
    targetElement = document.querySelector(".product-form__variants .block-swatch__radio:checked");
  }

  if (targetElement) {
    var productElement = targetElement.closest(".product");
  } else {
  }
  if (!productElement) return;

  updatePrice(productElement);
  // updatePrice();
  // var variant_id = e.detail.id;
  document.querySelectorAll(".addon-item").forEach(function(obj) {
    if(obj.querySelector(".addon-btn").classList.contains("added")) {
      obj.querySelector(".addon-btn").click();
    }
    var id = obj.getAttribute("data-for");
    if(id == variant_id) {
      obj.classList.remove("hide");
    }
    else {
      obj.classList.add("hide");
    }
  });
});


// Purana code affirm popup

// document.querySelectorAll(".trigger-affirm").forEach(function(obj) {
//   obj.addEventListener("click", function(e) {
//     if(document.querySelector(".affirm-modal-trigger")) {
//       document.querySelector(".affirm-modal-trigger").click();
//     }
//   });
// });

// New code affirm popup start
document.addEventListener("DOMContentLoaded", function() {

  document.querySelectorAll("strong").forEach(function(el) {

    if (el.textContent.includes("Prequalify now!")) {

      el.classList.add("trigger-affirm", "financing-affrim");

      el.style.cursor = "pointer";

    }

  });

});

document.addEventListener("click", function(e) {

  const trigger = e.target.closest(".trigger-affirm, .financing-affrim");

  if (!trigger) return;

  // If the element is a link with an href,
  // allow the link to work normally and don't open Affirm.
  if (trigger.tagName === "A" && trigger.getAttribute("href")) {
    return;
  }

  // Otherwise, trigger the Affirm popup
  const affirmTrigger = document.querySelector(".affirm-modal-trigger");

  if (affirmTrigger) {
    e.preventDefault();
    affirmTrigger.click();
  }

});

// New code affirm popup end